import { IOffer } from '../../../types';
import { pathOr } from 'ramda';
import { prepareAuthor } from './prepareAuthor';
import { prepareCalltracking } from './prepareCalltracking';
import { prepareGeo } from './prepareGeo';
import { prepareOfferPessimization } from './prepareOfferPessimization';
import { prepareOfferUrl } from './prepareOfferUrl';
import { preparePhotoFeatureIcons } from './preparePhotoFeatureIcons';
import { preparePhotoLabels } from './preparePhotoLabels';
import { prepareFeatures } from './prepareFeatures';

export const prepareOffer = (offer: IOffer) => {
  return {
    ...offer,
    isCalltrackingEnabled: !!offer.isCalltrackingEnabled,
    isExternalTourAvailable: !!offer.isExternalTourAvailable,
    callButtonTitle: offer.callButtonTitle || 'Позвонить',
    photoLabels: preparePhotoLabels(offer),
    author: prepareAuthor(offer.author),
    building: pathOr<IOffer['building'] | null>(null, ['building'], offer),
    calltracking: prepareCalltracking(offer.newbuildingDynamicCalltracking),
    geo: prepareGeo(offer.geo),
    href: prepareOfferUrl(offer),
    modelVersion: pathOr(null, ['mlSuggestionsInfiniteSearchResult', 'modelVersion'], offer),
    pessimization: prepareOfferPessimization(offer),
    promo: pathOr(null, ['promo'], offer),
    identicalOffers: pathOr(null, ['identicalOffers'], offer),
    groupedOffers: pathOr(null, ['groupedOffers'], offer),
    newbuildingId: pathOr(null, ['newbuildingId'], offer),
    showWarningMessage: !!offer.showWarningMessage,
    hasTour: pathOr(false, ['hasTour'], offer),
    photoFeatureIcons: preparePhotoFeatureIcons(offer),
    profitbaseBooking: pathOr(null, ['profitbaseBooking'], offer),
    isCianPartner: pathOr(false, ['isCianPartner'], offer),
    canBeBooked: pathOr(false, ['canBeBooked'], offer),
    isBookedFromDeveloper: pathOr(false, ['isBookedFromDeveloper'], offer),
    features: prepareFeatures(offer.features),
  };
};
